import React, { useEffect, useState } from 'react';
import { ScrollView, View } from 'react-native';
import {
  Button, Card, Colors, Dialog, Paragraph, Portal,
} from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';
import Icon from 'react-native-vector-icons/Ionicons';
import * as WebBrowser from 'expo-web-browser';

import styles from './styles';
import {
  Alert, AppHeader, CardPersonalTrainer,
} from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { confirmSubscription } from '../../../redux/actions/workerActions';
import { API } from '../../../service/api';

export default function ConfirmLive({ navigation }) {
  const [showAppointments, setShowAppointments] = useState(false);
  const [Agreement, setAgreement] = useState('');
  const [acceptAgreement, setAcceptAgreement] = useState(false);
  const [dialogNotAcceptAgreement, setDialogNotAcceptAgreement] = useState(false);

  useEffect(() => {
    API.get('/getseq/contrato_vigente/1').then((response) => setAgreement(response.data?.data[0]?.arquivo));
  }, []);

  const dispatch = useDispatch();
  const { userSignUp, trainerList } = useSelector((state) => state.user);
  const { availablePlans } = useSelector((state) => state.worker);
  const handleConfirmSubscription = () => {
    if (acceptAgreement) {
      dispatch(confirmSubscription(userSignUp, navigation));
      return navigation.navigate('Confirmed Subscription');
    }
    return setDialogNotAcceptAgreement(true);
  };
  const selectedTrainer = trainerList.find((trainer) => trainer.id_profissional === userSignUp.id_profissional);
  const selectedPlan = availablePlans.find((plan) => plan.id_plano === userSignUp.id_plano);
  const replaceValue = userSignUp.group_qnt > 1 ? selectedPlan?.valor / userSignUp.group_qnt : selectedPlan?.valor;
  const handleButtonAgreement = async () => {
    await WebBrowser.openBrowserAsync(Agreement);
  };
  return (
    <View>
      <Portal>
        <Dialog visible={dialogNotAcceptAgreement} onDismiss={() => setDialogNotAcceptAgreement(false)}>
          <Dialog.Title>Atenção</Dialog.Title>
          <Dialog.Content>
            <Paragraph>Para continuar você precisa aceitar o nossos Termos.</Paragraph>
          </Dialog.Content>
          <Dialog.Actions>

            <Button
              onPress={() => setDialogNotAcceptAgreement(false)}
            >
              Ok
            </Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
      <AppHeader navigation={navigation} hasBack title="Confirmar Plano" />
      <ScrollView style={styles.baseScroll}>
        <CardPersonalTrainer
          personalName={selectedTrainer?.nome}
          cref={selectedTrainer?.cref}
          exp={selectedTrainer?.mini_cv}
          isAll
          profilePic={selectedTrainer?.foto}
          data={{
            setAcceptAgreement,
            acceptAgreement,
            handleButtonAgreement,
          }}
          noButton
        />
        <Card style={styles.cardAppointments}>
          <AppButton style={styles.buttonAppointments} onPress={() => setShowAppointments(!showAppointments)}>
            <View style={styles.viewRowCenter}>
              <Icon name={showAppointments ? 'close' : 'add'} style={styles.iconAppointment} />
              <AppText size="bold" style={styles.textAppointment}>{`${showAppointments ? 'Esconder' : 'Mostrar'} Aulas Agendadas`}</AppText>
            </View>
          </AppButton>
          {showAppointments && (
            <View style={styles.viewBase}>
              <AppText style={styles.textDayNHour}>Dias</AppText>
              <View style={styles.groupButtonsHours}>
                { userSignUp.segunda === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Segunda" labelStyle={styles.textBadge} /> }
                { userSignUp.terca === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Terça" labelStyle={styles.textBadge} /> }
                { userSignUp.quarta === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Quarta" labelStyle={styles.textBadge} /> }
                { userSignUp.quinta === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Quinta" labelStyle={styles.textBadge} /> }
                { userSignUp.sexta === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Sexta" labelStyle={styles.textBadge} /> }
                { userSignUp.sabado === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Sábado" labelStyle={styles.textBadge} /> }
                { userSignUp.domingo === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Domingo" labelStyle={styles.textBadge} /> }
              </View>
              <AppText style={styles.textDayNHour}>Horário</AppText>
              <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label={userSignUp.horario} labelStyle={styles.textBadge} />
            </View>
          )}
        </Card>
        <Card style={styles.cardPayments}>
          <View style={styles.viewTitleCard}>
            <AppText style={styles.textTitleCard}>Forma de Pagamento</AppText>
          </View>
          <AppText style={styles.textSubTitleCard}>{`Valor: R$ ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(replaceValue)}`}</AppText>
          {/* <View style={styles.viewPayTypes}>
            <AppButton onPress={() => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, forma_pagamento: userSignUp.forma_pagamento === 'BOLETO' ? '' : 'BOLETO' } })} style={[styles.buttonBadge, userSignUp.forma_pagamento === 'BOLETO' && styles.buttonBadgeSelected]} label="Boleto" labelStyle={styles.textBadge} />
            <AppButton onPress={() => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, forma_pagamento: userSignUp.forma_pagamento === 'PIX' ? '' : 'PIX' } })} style={[styles.buttonBadge, userSignUp.forma_pagamento === 'PIX' && styles.buttonBadgeSelected]} label="PIX" labelStyle={styles.textBadge} />
          </View> */}
          <Alert
            icon="info"
            message="Após a confirmação de pagamento, entraremos em contato."
            backgroundColor={Colors.lightBlue800}
          />
          <AppButton
            // disabled={userSignUp.forma_pagamento === ''}
            size="bold"
            labelStyle={styles.textAppointment}
            label="Continuar"
            style={styles.buttonAppointments}
            onPress={handleConfirmSubscription}
          />
        </Card>
      </ScrollView>
    </View>
  );
}
